import styled, { css } from 'styled-components';

/* Heading/Bold */
const headingBoldTextStyles = css`
  font-weight: 700;
  line-height: 120%; /* 38.4px */
  color: #fff;
  position: relative;
  z-index: 1;
  letter-spacing: 0;
`;

/* Heading/Medium */
export const headingMediumTextStyles = `
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 33.6px */
`;

// Regular body text styles from Figma /* Body Text/Regular */
const regularBodyTextStyles = `
  font-weight: 400;
  line-height: 140%;
  color: #fff;
   position: relative;
  z-index: 1;
  letter-spacing: 0;
  `;

const bodyTextMedium = `
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  color: #fff;
  position: relative;
  z-index: 1;
`;

export const H1_HeadingBoldH4 = styled.h1`
  ${headingBoldTextStyles}
  font-size: 32px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const HeadingBoldH1 = styled.h1`
  ${headingBoldTextStyles}
  font-size: 24px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const HeadingBoldH3_fromH1 = styled.h3`
  ${headingBoldTextStyles}
  font-size: 36px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 26px;
  }
`;

export const HeadingBoldH3 = styled.h3`
  ${headingBoldTextStyles}
  font-size: 32px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

export const HeadingBoldH4 = styled.div`
  ${headingBoldTextStyles}
  font-size: 32px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;
export const HeadingBoldH5 = styled.div`
  ${headingBoldTextStyles}
  font-size: 28px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;
export const HeadingBoldH6 = styled.div`
  ${headingBoldTextStyles}
  font-size: 24px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 18px;
    font-weight: 500;
  }
`;
export const HeadingBoldH7 = styled.div`
  ${headingBoldTextStyles}
  font-size: 20px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 14px;
    font-weight: 500;
  }
`;

export const HeadingMediumH6 = styled.div`
  ${headingMediumTextStyles}
  font-size: 24px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const HeadingMediumH5 = styled.div`
  ${headingMediumTextStyles}
  font-size: 28px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

export const HeadingMediumH4 = styled.div`
  ${headingMediumTextStyles}
  font-size: 32px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const HeadingMediumH3 = styled.div`
  ${headingMediumTextStyles}
  font-size: 36px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;
export const BodyTextRegularA = styled.div`
  ${regularBodyTextStyles}
  font-size: 18px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    line-height: 130%;
    font-size: 16px;
  }
`;
export const BodyTextRegularB = styled.div`
  ${regularBodyTextStyles}
  font-size: 16px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    line-height: 130%;
    font-size: 14px;
  }
`;
export const BodyTextRegularC = styled.div`
  ${regularBodyTextStyles}
  font-size: 14px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    line-height: 130%;
    font-size: 12px;
  }
`;
export const BodyTextRegularD = styled.div`
  ${regularBodyTextStyles}
  font-size: 12px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 10px;
  }
`;
// TODO Миша сказал 8px на всех
export const BodyTextRegularE = styled.div`
  ${regularBodyTextStyles}
  font-size: 8px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 8px;
  }
`;


export const BodyTextMediumA = styled.div`
  ${bodyTextMedium}
  font-size: 18px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;
export const BodyTextMediumB = styled.div`
  ${bodyTextMedium}
  font-size: 16px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;
export const BodyTextMediumC = styled.div`
  ${bodyTextMedium}
  font-size: 14px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;
export const BodyTextMediumD = styled.div`
  ${bodyTextMedium}
  font-size: 12px;
  color: ${(props) => props.color || '#fff'};

  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

